<section>
  <app-check
    (loading)="getLoadingStatus($event)"
    (showNoResult)="getNoResultVisibility($event)"
    (complete)="getCompleteStatus($event)"
  ></app-check>
  <app-results [data]="dataResult" *ngIf="isComplete && !isLoading"></app-results>
  <app-status [data]="dataNoResult" *ngIf="isNoResult && !isLoading"></app-status>
</section>
